import Section from "../../common/Section/Section"
import IndustryInfoSection from "./IndustryInfoSection"
import IndustryCaseStudySection from "./IndustryCaseStudySection"
import toolsMain from "../../../assets/img/industries/tools/tools_main.webp"
import toolsCaseStudy from "../../../assets/img/industries/tools/tool_case_study_mobile.jpg"


export default function ToolIndustry() {
 const caseStudyInfo = {
  title: "Tools Case Study", description: (<>
   <p>Tool companies rely on equi-track for precise monitoring of tool usage, tracking each component within a tool, and managing maintenance both at the tool and component level. Previously, clients managed this complexity with spreadsheets, but equi-track’s dedicated Tool Management features have transformed their operations.</p>
   <p>Now, users can easily log job information, while equi-track automatically: </p>
   <ul>
    <li className="py-1">Counts the number of tool runs </li>
    <li className="py-1">Flags when maintenance is due for each component </li>
    <li className="py-1">Provides a full audit history for effective failure analysis </li>
   </ul>
   <p>This approach delivers the accuracy and traceability that tool companies need, all in one intuitive platform. </p>
  </>),
  img: toolsCaseStudy
 }

 const industryInfo = {
  description: (<>
   <ul className="list-unstyled">
    <li className="py-1 py-lg-3"><strong>Modular Tool Management: </strong> Assemble and disassemble tools with ease, with individual maintenance schedules for each component—swap parts as needed to keep tools in top condition.</li>
    <li className="py-1 py-lg-3"><strong>Rapid Allocation: </strong> Quickly reassign tools from job to job or well to well in just a few clicks, supporting fast-paced operations.</li>
    <li className="py-1 py-lg-3"><strong>Smart Usage Tracking: </strong> Automatically track tool usage and receive alerts when maintenance is due on any component, reducing downtime and extending tool life.</li>
   </ul>
  </>),
  img: toolsMain
 }

 return (
  <Section title="equi-track for Tools" isIndustryPage>
   <IndustryInfoSection industryInfo={industryInfo} />
   <IndustryCaseStudySection caseStudyInfo={caseStudyInfo} />
  </Section>
 )
}